import {getSalesReportAction} from "./actions";

export default function(state = {}, action) {
    switch (action.type) {
        case getSalesReportAction.resultAction:
            return {...state, [action.payload.postedData.eventId]: action.payload.data.data};
        default:
            return state;
    }
}